export const PLAN_BASE_ON_PRICE = {
  PEOPLE: 'people',
  ROOM: 'room'
}
